<template>
    <li class="flex items-center w-auto py-3 px-5" :data-country="countryCode" @click="changeLanguage(countryCode)">
      <div class="image-item h-8 w-10 mr-2" :style="{ background: 'center/contain no-repeat url(' + this.$root.publicPath + flagImage + ')'}">
      </div>
      <span class="md:hidden">{{ countryCode }}</span>
      <span class="hidden md:block">{{ text }}</span>
    </li>
</template>

<style lang="scss" scoped>
  li {
    cursor: pointer;
    :last-child {
      margin-bottom: 0;
    }
    &:hover {
      background-color: #999900;
    }
  }

</style>

<script>
export default {
  name: 'language-list-item',
  props: [
    'id',
    'countryCode',
    'flagImage',
    'text'
  ],
  methods: {
    changeLanguage (countryCode) {
      var currentLanguage = document.getElementById('current-language')
      this.$root.language = countryCode

      currentLanguage.classList.remove('chevron-up')
      currentLanguage.classList.add('chevron-down')
      document.getElementById('language-menu').classList.add('hidden')

      if (this.$root.allowAllCookies === true) {
        // Send our request to set the cookies.
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '/language-change', true)
        xhr.setRequestHeader('Accept', 'application/json; charset=UTF-8')
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        xhr.send(JSON.stringify({ cookiePolicy: this.$root.allowAllCookies, countryCode: countryCode }))
      }
    }
  }
}
</script>